<template>
  <v-col
    :cols="cols"
    :data-testid="dataTestid"
    class="mb-2"
  >
    <v-row dense>
      <v-col
        v-if="message"
        class="labeled-input"
        cols="12"
      >
        {{ $bct(message) }}

        <RequiredIndicator v-if="mandatory" />
      </v-col>

      <v-col cols="12">
        <RichTextEditor
          @change:text="emitHtml"
          ref="editorRef"
          :height="height"
          :initial-text="modelValue ?? ''"
          :initial-text-format="initialTextFormat"
        />
      </v-col>
    </v-row>
  </v-col>
</template>

<script setup>
import RequiredIndicator from '@/shared/components/RequiredIndicator.vue';
import RichTextEditor from '@/shared/components/RichTextEditor.vue';

const $bct = inject('translator');

const props = defineProps({
  cols: {
    type: [Number, String],
    default: 12,
  },
  dataTestid: {
    type: String,
    default: 'labeled-rich-text-editor',
  },
  height: {
    type: [Number, String],
    default: 250,
  },
  initialTextFormat: {
    type: String,
    default: 'html',
    validator: (value) => ['html', 'markdown', 'plaintext'].includes(value),
  },
  mandatory: {
    type: Boolean,
    default: false,
  },
  message: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['update:modelValue']);

const modelValue = defineModel({ type: String });

const editorRef = ref(null);

watch(
  () => modelValue.value,
  (newVal) => {
    if (!editorRef.value) return;
    const current = editorRef.value.getSemanticHTML();
    if (newVal != null && newVal !== current) {
      editorRef.value.setText(newVal || '', props.initialTextFormat);
    }
  },
  { immediate: false },
);

function emitHtml(source) {
  if (source !== 'user') return;

  const html = editorRef.value?.getSemanticHTML() ?? '';
  emit('update:modelValue', html);
}
</script>
